(function() {
  if (window.VoneaStoriesLoaded) {
    if (typeof window.VoneaStoriesInit === 'function') window.VoneaStoriesInit();
    return;
  }

  window.VoneaStoriesLoaded = true;

  const SELECTORS = {
    section: '[data-vonea-stories]',
    rail: '[data-vonea-stories-rail]',
    dot: '[data-vonea-story-dot]',
    action: '[data-vonea-story-action]'
  };

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function createIcon(type) {
    if (type === 'sound-on') {
      return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 10v4h4l5 4V6l-5 4H4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M16 9.5c.8.7 1.2 1.5 1.2 2.5S16.8 13.8 16 14.5M18.4 7.2A6.6 6.6 0 0 1 20.5 12a6.6 6.6 0 0 1-2.1 4.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    }

    if (type === 'sound-off') {
      return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 10v4h4l5 4V6l-5 4H4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M17 10l4 4M21 10l-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    }

    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  function playVideo(video) {
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function() {});
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  async function addVariantToCart(variantId, quantity) {
    const cartDrawer = getCartDrawer();
    const payload = {
      id: Number(variantId),
      quantity: quantity || 1
    };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      payload.sections = cartDrawer.getSectionsToRender().map(function(section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
    }

    const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || 'Unable to add this product to your bag.');
    }

    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
      cartDrawer.renderContents(data);
      return;
    }

    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      cartLink.click();
      return;
    }

    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function createPlayer(section) {
    const player = document.createElement('div');
    player.className = 'vonea-story-player';
    player.setAttribute('role', 'dialog');
    player.setAttribute('aria-modal', 'true');
    player.setAttribute('aria-label', 'Product stories');
    player.innerHTML = [
      '<div class="vonea-story-player__backdrop" data-vonea-story-close></div>',
      '<div class="vonea-story-player__dialog" tabindex="-1">',
      '  <div class="vonea-story-player__stage">',
      '    <div class="vonea-story-player__progress"></div>',
      '    <button class="vonea-story-player__close" type="button" aria-label="Close stories" data-vonea-story-close>' + createIcon('close') + '</button>',
      '    <button class="vonea-story-player__mute" type="button" aria-label="Switch sound on" data-vonea-story-mute>' + createIcon('sound-off') + '</button>',
      '    <div class="vonea-story-player__tap vonea-story-player__tap--left" aria-hidden="true" data-vonea-story-prev></div>',
      '    <div class="vonea-story-player__tap vonea-story-player__tap--right" aria-hidden="true" data-vonea-story-next></div>',
      '  </div>',
      '</div>'
    ].join('');

    section.appendChild(player);
    return player;
  }

  function initStoriesSection(section) {
    if (!section || section.dataset.voneaStoriesReady === 'true') return;
    section.dataset.voneaStoriesReady = 'true';

    const rail = qs(section, SELECTORS.rail);
    if (!rail) return;

    const player = qs(section, '.vonea-story-player') || createPlayer(section);
    const dialog = qs(player, '.vonea-story-player__dialog');
    const stage = qs(player, '.vonea-story-player__stage');
    const progress = qs(player, '.vonea-story-player__progress');
    const muteButton = qs(player, '[data-vonea-story-mute]');
    const prevArea = qs(player, '[data-vonea-story-prev]');
    const nextArea = qs(player, '[data-vonea-story-next]');

    let currentIndex = -1;
    let currentVideo = null;
    let bars = [];
    let muted = true;
    let rafId = 0;
    let startY = 0;
    let holdTimer = 0;

    function getItems() {
      return qsa(rail, SELECTORS.dot);
    }

    function buildBars(count) {
      progress.innerHTML = '';
      bars = [];

      for (let index = 0; index < count; index += 1) {
        const bar = document.createElement('div');
        bar.className = 'vonea-story-player__bar';
        bar.innerHTML = '<span></span>';
        progress.appendChild(bar);
        bars.push(qs(bar, 'span'));
      }
    }

    function setBar(index, percent) {
      if (!bars[index]) return;
      bars[index].style.width = Math.max(0, Math.min(100, percent)) + '%';
    }

    function clearStage() {
      cancelAnimationFrame(rafId);
      rafId = 0;

      if (currentVideo) {
        try { currentVideo.pause(); } catch (error) {}
        currentVideo.removeAttribute('src');
        currentVideo.load();
        currentVideo.remove();
        currentVideo = null;
      }

      qsa(stage, '.vonea-story-player__video').forEach(function(video) {
        try { video.pause(); } catch (error) {}
        video.removeAttribute('src');
        video.load();
        video.remove();
      });

      qsa(stage, '.vonea-story-player__badge, .vonea-story-card').forEach(function(element) {
        element.remove();
      });
    }

    function createBadge(dot) {
      const badge = document.createElement('a');
      badge.className = 'vonea-story-player__badge';
      badge.href = dot.getAttribute('data-url') || '#';
      badge.innerHTML = '<span class="vonea-story-player__badge-text"></span>';
      qs(badge, '.vonea-story-player__badge-text').textContent = dot.getAttribute('data-title') || 'View product';
      stage.appendChild(badge);
    }

    function createPrice(dot) {
      const template = qs(dot, 'template[data-price]');
      const price = document.createElement('div');
      price.className = 'vonea-story-card__price';
      price.innerHTML = template ? template.innerHTML : '';
      return price;
    }

    function createVariantSelect(variants) {
      if (variants.length <= 1) return null;

      const wrapper = document.createElement('div');
      wrapper.className = 'vonea-story-card__variant';

      const label = document.createElement('label');
      label.className = 'vonea-story-sr-only';
      label.textContent = 'Choose an option';

      const select = document.createElement('select');
      select.className = 'vonea-story-card__select';

      variants.forEach(function(variant) {
        const option = document.createElement('option');
        option.value = variant.id;
        option.disabled = !variant.available;
        option.textContent = variant.title + (variant.available ? '' : ' - sold out');
        select.appendChild(option);
      });

      const firstAvailable = variants.find(function(variant) {
        return variant.available;
      });

      if (firstAvailable) select.value = firstAvailable.id;

      label.setAttribute('for', 'vonea-story-variant-' + Math.random().toString(36).slice(2));
      select.id = label.getAttribute('for');

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      return wrapper;
    }

    function getVariants(dot) {
      const script = qs(dot, 'script[type="application/json"]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent || '[]');
      } catch (error) {
        return [];
      }
    }

    function createProductCard(dot) {
      const variants = getVariants(dot);
      const firstAvailable = variants.find(function(variant) {
        return variant.available;
      }) || variants[0];

      const card = document.createElement('div');
      card.className = 'vonea-story-card';

      const meta = document.createElement('div');
      meta.className = 'vonea-story-card__meta';

      const title = document.createElement('h3');
      title.className = 'vonea-story-card__title';
      title.textContent = dot.getAttribute('data-title') || '';

      meta.appendChild(title);
      meta.appendChild(createPrice(dot));
      card.appendChild(meta);

      const variantSelect = createVariantSelect(variants);
      if (variantSelect) card.appendChild(variantSelect);

      const actions = document.createElement('div');
      actions.className = 'vonea-story-card__actions';

      const addButton = document.createElement('button');
      addButton.className = 'vonea-story-card__button vonea-story-card__button--primary';
      addButton.type = 'button';
      addButton.textContent = 'Add to bag';

      const viewLink = document.createElement('a');
      viewLink.className = 'vonea-story-card__button';
      viewLink.href = dot.getAttribute('data-url') || '#';
      viewLink.textContent = 'View product';

      actions.appendChild(addButton);
      actions.appendChild(viewLink);
      card.appendChild(actions);

      const status = document.createElement('p');
      status.className = 'vonea-story-card__status';
      status.hidden = true;
      card.appendChild(status);

      if (!firstAvailable || !firstAvailable.available) {
        addButton.disabled = true;
        addButton.textContent = 'Sold out';
      }

      addButton.addEventListener('click', async function() {
        const select = qs(card, '.vonea-story-card__select');
        const variantId = select ? select.value : (firstAvailable ? firstAvailable.id : dot.getAttribute('data-variant-id'));

        if (!variantId) return;

        addButton.disabled = true;
        status.hidden = true;

        try {
          await addVariantToCart(variantId, 1);
          close();
        } catch (error) {
          status.textContent = error.message || 'Unable to add this product to your bag.';
          status.hidden = false;
          addButton.disabled = false;
        }
      });

      stage.appendChild(card);
    }

    function updateProgress(durationFallback) {
      if (!currentVideo || currentIndex < 0) return;

      const duration = currentVideo.duration || durationFallback || 8;
      const current = Math.min(currentVideo.currentTime || 0, duration);
      setBar(currentIndex, (current / duration) * 100);
      rafId = requestAnimationFrame(function() {
        updateProgress(durationFallback);
      });
    }

    function openAt(index) {
      const items = getItems();
      if (index < 0 || index >= items.length) {
        close();
        return;
      }

      currentIndex = index;
      clearStage();
      buildBars(items.length);

      for (let completedIndex = 0; completedIndex < index; completedIndex += 1) {
        setBar(completedIndex, 100);
      }

      const dot = items[index];
      const source = dot.getAttribute('data-video-url');
      if (!source) {
        next();
        return;
      }

      const video = document.createElement('video');
      video.className = 'vonea-story-player__video';
      video.src = source;
      video.preload = 'auto';
      video.playsInline = true;
      video.muted = muted;

      currentVideo = video;
      stage.appendChild(video);
      createBadge(dot);
      createProductCard(dot);

      const durationFallback = Number(dot.getAttribute('data-duration') || '0') || 8;

      video.addEventListener('play', function() {
        cancelAnimationFrame(rafId);
        updateProgress(durationFallback);
      });

      video.addEventListener('pause', function() {
        cancelAnimationFrame(rafId);
      });

      video.addEventListener('ended', next);

      playVideo(video);
    }

    function getClickedStory(event) {
      const trigger = event.target.closest(SELECTORS.action);
      const dot = trigger ? trigger.closest(SELECTORS.dot) : event.target.closest(SELECTORS.dot);

      if (!dot || !rail.contains(dot)) return null;
      return dot;
    }

    function bindStoryTriggers() {
      getItems().forEach(function(dot) {
        const trigger = qs(dot, SELECTORS.action) || dot;
        if (!trigger || trigger.dataset.voneaStoryTriggerReady === 'true') return;

        trigger.dataset.voneaStoryTriggerReady = 'true';

        trigger.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();

          const items = getItems();
          const index = items.indexOf(dot);
          if (index >= 0) open(index);
        }, true);

        trigger.addEventListener('keydown', function(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;

          event.preventDefault();
          event.stopPropagation();

          const items = getItems();
          const index = items.indexOf(dot);
          if (index >= 0) open(index);
        }, true);
      });
    }

    function open(index) {
      player.style.display = 'block';
      player.style.position = 'fixed';
      player.style.inset = '0';
      player.style.zIndex = '999999';
      player.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      dialog.focus();
      openAt(index);
    }

    function close() {
      clearStage();
      player.classList.remove('is-open');
      player.style.display = 'none';
      document.documentElement.style.overflow = '';
      currentIndex = -1;
    }

    function prev() {
      if (currentIndex <= 0) {
        close();
        return;
      }

      openAt(currentIndex - 1);
    }

    function next() {
      const items = getItems();
      if (currentIndex >= items.length - 1) {
        close();
        return;
      }

      openAt(currentIndex + 1);
    }

    function toggleMute() {
      muted = !muted;

      if (currentVideo) {
        currentVideo.muted = muted;
        if (!muted) playVideo(currentVideo);
      }

      muteButton.setAttribute('aria-label', muted ? 'Switch sound on' : 'Switch sound off');
      muteButton.innerHTML = muted ? createIcon('sound-off') : createIcon('sound-on');
    }

    rail.addEventListener('click', function(event) {
      const dot = getClickedStory(event);
      if (!dot) return;

      const items = getItems();
      const index = items.indexOf(dot);
      if (index >= 0) open(index);
    });

    rail.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const dot = getClickedStory(event);
      if (!dot) return;

      event.preventDefault();
      const items = getItems();
      const index = items.indexOf(dot);
      if (index >= 0) open(index);
    });

    bindStoryTriggers();

    qsa(player, '[data-vonea-story-close]').forEach(function(closeButton) {
      closeButton.addEventListener('click', close);
    });

    prevArea.addEventListener('click', prev);
    nextArea.addEventListener('click', next);
    muteButton.addEventListener('click', toggleMute);

    stage.addEventListener('pointerdown', function() {
      if (!currentVideo) return;
      holdTimer = setTimeout(function() {
        if (currentVideo) currentVideo.pause();
      }, 180);
    });

    stage.addEventListener('pointerup', function() {
      clearTimeout(holdTimer);
      if (currentVideo && currentVideo.paused) playVideo(currentVideo);
    });

    stage.addEventListener('touchstart', function(event) {
      startY = event.touches[0].clientY;
    }, { passive: true });

    stage.addEventListener('touchend', function(event) {
      const touch = event.changedTouches[0];
      if (touch && touch.clientY - startY > 70) close();
    }, { passive: true });

    document.addEventListener('keydown', function(event) {
      if (!player.classList.contains('is-open')) return;

      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') prev();
      if (event.key === 'ArrowRight') next();

      if (event.key === ' ') {
        event.preventDefault();
        if (!currentVideo) return;
        if (currentVideo.paused) playVideo(currentVideo);
        else currentVideo.pause();
      }
    });
  }

  function boot(root) {
    qsa(root || document, SELECTORS.section).forEach(initStoriesSection);
  }

  window.VoneaStoriesInit = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    boot(event.target);
  });
})();

